<div class="hero-slide" [class.active]="isActive">
  <!-- Background Image with Overlay -->
  <div class="slide-bg" [style.background-image]="'url(' + slide.image + ')'">
    <div class="overlay"></div>
  </div>

  <div class="container slide-content">
    <div class="content-wrapper floating-content">
      <h1 class="headline">{{ slide.headline }}</h1>
      <div class="cta-wrapper">
        <app-button variant="glass-glow" routerLink="/about">{{ slide.ctaText }}</app-button>
      </div>
      <p class="subtext">{{ slide.subtext }}</p>
    </div>
  </div>
</div>
